import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import useSWR from "swr";
import Home from "./pages/Home";
import AboutUs from "./pages/About";
import ContactUs from "./pages/Contact";
import Services from "./pages/Services";
import Careers from "./pages/Careers";
import Leadership from "./pages/Leadership";
import Facilities from "./pages/Facilities";
import ServicesNew from "./pages/ServicesNew";

import NotFound from "./pages/NotFound";
import { secureFetcher, SECURITY_CONFIG } from "./config/security";
import PriceCalculator from "./pages/PriceCalculator";
import ServiceDetails from "./pages/ServiceDetails";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const { data: navigationData } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.MENU_ENDPOINT}`,
    secureFetcher,
  );

  const [showPopup, setShowPopup] = useState(false);
  const [popupImage, setPopupImage] = useState("");

  useEffect(() => {
    // Select image based on screen size
    if (window.innerWidth <= 480) {
      setPopupImage(
        "https://47.activ8.digital/wp-content/uploads/2025/08/14thAugestPopUpMobile.png",
      ); // Mobile image URL
    } else {
      setPopupImage(
        "https://47.activ8.digital/wp-content/uploads/2025/08/14thAugestPopUp.png",
      ); // Desktop image URL
    }

    // Check if popup was closed before
    const FlagpopupClosed = localStorage.getItem("FlagpopupClosed");
    if (!FlagpopupClosed) {
      setShowPopup(false);
    }
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
    localStorage.setItem("FlagpopupClosed", "false");
  };

  // ==== Preloader Logic (Your Existing Code) ====
  useEffect(() => {
    if (window.location.hostname !== "localhost") {
      console.log = () => {};
      console.warn = () => {};
      console.error = () => {};
    }

    if (
      window.location.pathname.includes("/contact") ||
      window.location.pathname.includes("/admin")
    ) {
      const meta = document.createElement("meta");
      meta.httpEquiv = "Cache-Control";
      meta.content = "no-cache, no-store, must-revalidate";
      document.head.appendChild(meta);
    }

    const preloader = document.getElementById("preloader");
    const body = document.body;

    body.classList.add("loading");
    const minDisplayTime = 2000;
    const startTime = Date.now();

    function hidePreloader() {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(0, minDisplayTime - elapsedTime);

      setTimeout(() => {
        if (preloader) {
          preloader.classList.add("fade-out");
        }
        body.classList.remove("loading");
        body.classList.add("loaded");
        setTimeout(() => {
          if (preloader) {
            preloader.style.display = "none";
          }
        }, 500);
      }, remainingTime);
    }

    if (document.readyState === "complete") {
      hidePreloader();
    } else {
      window.addEventListener("load", hidePreloader);
    }

    const fallbackTimeout = setTimeout(hidePreloader, 2000);

    return () => {
      window.removeEventListener("load", hidePreloader);
      clearTimeout(fallbackTimeout);
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header data={navigationData} />

      {/* Popup */}
      {showPopup && (
        <div className="flag-popup-overlay" style={popupOverlayStyle}>
          <div className="flag-popup-content" style={popupContentStyle}>
            <img src={popupImage} alt="Popup" style={{ maxWidth: "100%" }} />
            <button onClick={handleClosePopup} style={popupCloseBtnStyle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M2.66683 23.6667L0.333496 21.3333L9.66683 12L0.333496 2.66667L2.66683 0.333332L12.0002 9.66667L21.3335 0.333332L23.6668 2.66667L14.3335 12L23.6668 21.3333L21.3335 23.6667L12.0002 14.3333L2.66683 23.6667Z"
                  fill="White"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/services2" element={<Services />} />
        <Route path="/services" element={<ServicesNew />} />
        <Route path="/services/:id" element={<ServiceDetails />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/price-calculator" element={<PriceCalculator />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

// ==== Basic Styles (Inline for Demo) ====
const popupOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const popupContentStyle = {
  position: "relative",
  maxWidth: "60%",
  textAlign: "center",
};

const popupCloseBtnStyle = {
  position: "absolute",
  top: "15px",
  right: "20px",
  cursor: "pointer",
  background: "transparent",
  border: "none",
  borderRadius: "50%",
  width: "25px",
  height: "25px",
};

export default App;
